import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {UserResponse} from '@middleware/models/user-response';
import {UserService} from '@services/user/user.service';

@Injectable({providedIn: 'root'})
export class UserResolver implements Resolve<UserResponse | null> {
  constructor(private readonly userService: UserService) {}
  resolve(): Promise<UserResponse | null> {
    return this.userService.userPromise;
  }
}
